<template>
  <div>
    <label v-if="label" class="form-label block mb-2">{{ label }}</label>
    <input
      type="text"
      v-model="search"
      placeholder="Buscar ícono..."
      class="form-input w-full mb-2"
    />
    <div class="flex flex-wrap gap-2 max-h-64 overflow-y-auto p-1 border rounded">
      <button
        v-for="iconName in filteredIcons"
        :key="iconName"
        type="button"
        :title="iconName"
        class="w-12 h-12 flex items-center justify-center rounded border"
        :class="modelValue === iconName ? 'border-indigo-500 bg-indigo-50' : 'border-gray-200'"
        @click="$emit('update:modelValue', iconName)"
      >
        <icon :name="iconName" class="w-6 h-6 fill-gray-600" />
      </button>
      <div v-if="filteredIcons.length === 0" class="text-sm text-gray-400 p-2">Sin resultados.</div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export const ALL_ICONS = [
  'academic-cap', 'adjustments-horizontal', 'airplay', 'all_users', 'angle-up', 'aperture', 'apple', 'archive-box',
  'at-symbol', 'banknotes', 'battery-100', 'bd', 'beaker', 'bell', 'bell-alert', 'bolt',
  'bolt-slash', 'book', 'br', 'briefcase', 'bug-ant', 'building-library', 'building-office', 'building-office-2',
  'building-storefront', 'buildings', 'cake', 'calculator', 'calendar', 'calendar-days', 'camera', 'category',
  'chart', 'chart-bar', 'chart-pie', 'chat', 'chat-bubble-left', 'chat-bubble-left-right', 'chat-bubble-oval-left', 'check',
  'check-badge', 'check-circle', 'cheveron-down', 'cheveron-right', 'clipboard', 'clipboard-document', 'clipboard-document-check', 'clipboard-document-list',
  'clock', 'close', 'cn', 'code-bracket', 'cog', 'cog-6-tooth', 'cog-8-tooth', 'command-line',
  'compass', 'computer-desktop', 'contact', 'cpu-chip', 'credit-card', 'cross', 'cube', 'cube-transparent',
  'dash', 'dashboard', 'de', 'departments', 'device-phone-mobile', 'device-tablet', 'document', 'document-check',
  'document-duplicate', 'document-text', 'down', 'edit', 'email', 'email_template', 'en', 'envelope',
  'envelope-open', 'es', 'exclamation-circle', 'exclamation-triangle', 'eye', 'eye-slash', 'face-smile', 'faq',
  'file', 'film', 'finger-print', 'fire', 'flag', 'folder', 'folder-open', 'funnel',
  'gear', 'gif', 'gift', 'global_setting', 'globe-alt', 'globe-americas', 'hand-raised', 'hand-thumb-down',
  'hand-thumb-up', 'he', 'heart', 'home', 'home-modern', 'identification', 'image', 'inbox',
  'information-circle', 'it', 'key', 'knowledge', 'lifebuoy', 'light-bulb', 'link', 'list',
  'list-bullet', 'location', 'lock-closed', 'lock-open', 'login', 'lt', 'magnifying-glass', 'map',
  'map-pin', 'megaphone', 'microphone', 'moon', 'musical-note', 'newspaper', 'nl', 'no-symbol',
  'no_image', 'notes', 'office', 'page', 'paint-brush', 'palette', 'paper-airplane', 'pending_users',
  'phone', 'phone-arrow-down-left', 'photo', 'plus', 'post', 'power', 'presentation-chart-bar', 'printer',
  'priorities', 'pt', 'puzzle-piece', 'qr-code', 'question-mark-circle', 'queue-list', 'radio', 'receipt-percent',
  'rectangle-stack', 'rocket-launch', 'rss', 'sa', 'scale', 'scissors', 'se', 'security',
  'send', 'send_plan', 'server', 'server-stack', 'service', 'settings', 'shield-check', 'shield-exclamation',
  'shopping-bag', 'shopping-cart', 'signal', 'sparkles', 'speaker-wave', 'squares-2x2', 'star', 'status',
  'store-front', 'sun', 'swatch', 'table-cells', 'tag', 'tick', 'ticket', 'to_up',
  'trash', 'trophy', 'truck', 'tv', 'types', 'up', 'user', 'user-circle',
  'user-group', 'user_role', 'users', 'video-camera', 'video_beam', 'view-columns', 'wallet', 'wifi',
  'window', 'wrench', 'wrench-screwdriver', 'x-circle',
]

export default {
  components: { Icon },
  props: {
    modelValue: { type: String, default: null },
    label: { type: String, default: 'Ícono' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      search: '',
    }
  },
  computed: {
    filteredIcons() {
      if (!this.search) return ALL_ICONS
      const q = this.search.toLowerCase()
      return ALL_ICONS.filter(name => name.toLowerCase().includes(q))
    },
  },
}
</script>
